<template>
  <div class="d-flex">
    <FolderDrawer>
    </FolderDrawer>
    <div class="flex-grow-1"
         :class="{'ml-0': rootFolders.length }">
      <div class="ml-2 mb-2">
        <div class="d-flex pt-2">
          <v-select v-if="1===2"
                    label="Where"
                    outlined
                    v-model="scope"
                    :items="scopes"
                    item-text="name"
                    item-value="id"
                    class="mr-4"
                    dense
                    @change="changeScope">
          </v-select>

          <v-select v-if="team.brands_enabled"
                    label="Brand"
                    outlined
                    v-model="brand"
                    :items="myBrands"
                    item-value="id"
                    item-text="name"
                    class="mr-4"
                    dense
                    @change="changeBrand">
          </v-select>

          <v-select label="Type"
                    outlined
                    v-model="type"
                    :items="presentationTypes"
                    item-text="name"
                    item-value="id"
                    class="mr-4"
                    dense
                    @change="changeType">
          </v-select>

          <v-select label="Tag"
                    outlined
                    v-model="label"
                    :items="allLabels"
                    item-text="name"
                    item-value="id"
                    class="mr-4"
                    dense
                    @change="changeLabel">
          </v-select>

          <v-select label="Shareable"
                    outlined
                    v-model="canBeShared"
                    :items="yesNoOptions"
                    item-text="name"
                    item-value="id"
                    class="mr-4"
                    dense
                    @change="changeCanBeShared">
          </v-select>

          <v-select v-if="isHome"
                    label="Sort by"
                    outlined
                    v-model="homeSortOption"
                    :items="sortOptions"
                    item-text="name"
                    return-object
                    :disabled="isSortByDisabled"
                    :append-icon="homeSortOption.icon"
                    dense
                    @change="changeSortOption">
          </v-select>
          <v-select v-else
                    label="Sort by"
                    outlined
                    v-model="sortOption"
                    :items="sortOptions"
                    item-text="name"
                    return-object
                    :append-icon="sortOption.icon"
                    dense
                    @change="changeSortOption">
          </v-select>
        </div>
        <div class="d-flex align-center">
          <v-text-field label="Name"
                        outlined
                        v-model="name"
                        placeholder="Search by name (comma-separated)"
                        class="mr-2"
                        dense
                        hide-details
                        clearable
                        @click:clear="clearNameField"
                        @keydown.enter.prevent="searchPresentations">
          </v-text-field>

          <v-btn color="primary"
                 @click.prevent="searchPresentations"
                 class="mr-2">
            Search
          </v-btn>

          <v-btn color="secondary"
                 @click.prevent="resetForm">
            Reset
          </v-btn>
        </div>

      </div>

      <h2 v-if="folder"
          class="ml-3 mb-2 d-flex align-center">
        <v-icon left>
          {{ folder.icon ?? 'fas fa-folder-open' }}
        </v-icon>
        {{ folder.name }}: {{ numFiles }}
      </h2>
      <v-divider class="ml-2 mb-2">
      </v-divider>
      <template v-if="filteredPresentations.length > 0">
        <div class="ContentWindow"
             v-resize="onResize"
             :style="contentWindowStyle">
          <div ref="contentWindow"
               class="d-flex flex-wrap">
            <presentation-card v-for="presentation in sortedPresentations"
                               :key="presentation.id"
                               :presentation="presentation"
                               @dismiss="$emit('dismiss')">
            </presentation-card>
          </div>
        </div>
      </template>
      <template v-if="filteredPresentations.length === 0">
        <v-alert type="info"
                 class="ml-3"
                 outlined
                 text
                 v-if="isHome">
          <div v-if="rootFolders.length">
            Select a folder on the left.
          </div>
          <div v-else>
            There are no files here.
          </div>
        </v-alert>
        <v-alert type="info"
                 class="ml-3"
                 outlined
                 text
                 v-else-if="isBookmarks">
          You don't have any favorites.
        </v-alert>
        <v-alert type="info"
                 class="ml-3"
                 outlined
                 text
                 v-else>
          <div v-if="folder && folder.children.length">
            Select a different folder or subfolder on the left.
          </div>
          <div v-else
               class="ml-4">
            Select a different folder on the left.
          </div>
        </v-alert>
      </template>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {clone, orderBy} from 'lodash';
import pluralize from 'pluralize';
import FolderDrawer from './FolderDrawer';
import PresentationCard from './PresentationCard';

export default {
  components: {PresentationCard, FolderDrawer},
  data() {
    return {
      windowSize: { // MLD-3565
        x: 0,
        y: 0,
        top: 0,
        left: 0,
      }
    }
  },
  watch: {
    form(newVal) {

    },
  },
  computed: {
    ...mapGetters([
      'labels', // MLD-3565
      'team',
      'user',
    ]),
    ...mapGetters('content', [
      'activeBrands', // MLD-4796
      'activeProducts', // MLD-3306
      'bookmarkedPresentations',
      'brands',
      'filteredPresentations', // MLD-7739
      'folder',
      'form', // MLD-3565
      'isHome',
      'isBookmarks', // MLD-2107
      'isMyFolder', // MLD-2729
      'isNewFolder', // MLD-5639
      'isSlidesFolder', // MLD-6435
      'presentations',
      'presentationTypes', // MLD-3565
      'rootFolders',
      'scopes', // MLD-3565
      'sortOptions',
      'yesNoOptions', // MLD-3565
    ]),
    isSortByDisabled() { // MLD-5560
      if (this.isHome) {
        return this.team.is_home_folder_sorted_by_user === false
      }
      return false;
    },
    contentWindowStyle() { // MLD-3565
      if (this.windowSize && this.windowSize.top) {
        const offset = this.windowSize.top + 30;
        if (offset > 30) {
          return `height: calc(100vh - ${offset}px); overflow-y: auto;`;
        }
      }
      return '';
    },
    numFiles() {
      return pluralize('File', this.filteredPresentations.length, true);
    },
    myBrands() { // MLD-4796
      const brands = clone(this.activeBrands);
      brands.unshift({
        id: '',
        name: 'Any',
      })
      return brands;
    },
    allProducts() {
      const products = clone(this.activeProducts);
      products.unshift({
        id: '',
        name: 'Any',
      })
      return products;
    },
    allLabels() {
      const labels = clone(this.labels);
      labels.unshift({
        id: '',
        name: 'Any',
      })
      return labels;
    },
    activeFolders: {
      get() {
        return this.$store.state.content.activeFolders;
      },
      set(val) {
        this.$store.commit('content/setActiveFolders', val)
      },
    },
    sortedPresentations() {
      let sortOption = this.sortOption;
      if (this.isHome) { // MLD-5560
        sortOption = this.homeSortOption;
        if (this.team.is_home_folder_sorted_by_date) {
          sortOption = this.sortOptions[1];
        } else if (this.team.is_home_folder_sorted_by_name) {
          sortOption = this.sortOptions[0];
        }
      }
      if (sortOption) {
        return orderBy(this.filteredPresentations, sortOption.fields, sortOption.orders);
      }
      return this.filteredPresentations;
    },
    filterForm: {
      get() {
        return this.$store.state.content.form;
      }
    },
    scope: {
      get() {
        return this.filterForm.scope;
      },
      set(val) {
        //this.$store.commit('content/setFormScope', val);
        this.$store.dispatch('content/setFormScope', val);
      }
    },
    brand: { // MLD-4796
      get() {
        return this.filterForm.brand;
      },
      set(val) {
        this.$store.dispatch('content/setBrand', val);
      }
    },
    product: {
      get() {
        return this.filterForm.product;
      },
      set(val) {
        this.$store.dispatch('content/setProduct', val);
      }
    },
    type: {
      get() {
        return this.filterForm.type;
      },
      set(val) {
        this.$store.commit('content/setFormValue', {key: 'type', value: val})
      }
    },
    label: {
      get() {
        return this.filterForm.label;
      },
      set(val) {
        this.$store.commit('content/setFormValue', {key: 'label', value: val})
      }
    },
    canBeShared: {
      get() {
        return this.filterForm.can_be_shared;
      },
      set(val) {
        this.$store.commit('content/setFormValue', {key: 'can_be_shared', value: val})
      }
    },
    homeSortOption: {
      get() {
        return this.$store.state.content.homeSortOption;
      },
      set(val) {
        this.$store.dispatch('content/setHomeSortOption', val);
      },
    },
    sortOption: {
      get() {
        return this.$store.state.content.sortOption;
      },
      set(val) {
        this.$store.dispatch('content/setSortOption', val);
      },
    },
    name: {
      get() {
        return this.filterForm.name;
      },
      set(val) {
        this.$store.dispatch('content/setFormValue', {key: 'name', value: val})
      },
    },
  },
  created() {
    this.$store.dispatch('content/initializeHomeSortOption', this.team);
  },
  methods: {
    changeScope() {
      //console.log('changeScope START', this.scope);
      this.searchPresentations();
    },
    changeBrand() {
      //console.log('changeBrand START', this.brand);
      this.searchPresentations();
    },
    changeType() {
      //console.log('changeType START', this.type);
      this.searchPresentations();
    },
    changeLabel() {
      //console.log('changeLabel START', this.label);
      this.searchPresentations();
    },
    changeCanBeShared() {
      //console.log('changeCanBeShared START', this.canBeShared);
      this.searchPresentations();
    },
    changeSortOption() {
      //console.log('changeSortOption START', this.sortOption);
      this.searchPresentations();
    },
    async resetForm() {
      await this.$store.dispatch('content/resetForm', this.team);
      this.searchPresentations();
    },
    clearNameField() {
      this.name = '';
      this.searchPresentations();
    },
    searchPresentations() {
      this.$store.dispatch('content/searchPresentations', this.team);
    },
    onResize() { // MLD-3565
      const contentWindow = this.$refs.contentWindow;
      if (contentWindow) {
        const viewportOffset = contentWindow.getBoundingClientRect();
        this.windowSize = {
          x: window.innerWidth,
          y: window.innerHeight,
          //viewportOffset,
          top: viewportOffset.top,
          left: viewportOffset.left,
        }
      }
    }
  }
}
</script>
